import { createSlice } from '@reduxjs/toolkit';

const academyDataSlice = createSlice({
  name: 'academyData',
  initialState: {
    data: [],
    courses: [],
    menu: [],
    showBanner: null,
    metadata: null
  },
  reducers: {
    info(state, action) {
      state.data = action.payload.academyData;
    },
    courses(state, action) {
      state.courses = action.payload.coursesData.lstCourseVO;
    },
    menu(state, action) {
      state.menu = action.payload.academyMenuData.menus;
    },
    showBanner(state, action) {
      state.showBanner = action.payload.showBanner;
    },
    metadata(state, action) {
      state.metadata = action.payload.metadataAcademy;
    }
  }
});

export const academyDataActions = academyDataSlice.actions;

export default academyDataSlice;
